import React, { useState, useEffect } from "react";
import WaterCoolerHeader from "./WaterCoolerHeader/WaterCoolerHeader";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import { messageCount } from "services/TwilioService";
import InfiniteScroll from "react-infinite-scroll-component";
import Scrollbar from "react-scrollbars-custom";
import WaterCoolerFooter from "./WaterCoolerFooter";
import WaterCoolerContent from "./WaterCoolerContent";
import WaterCoolerVideoContent from "./WaterCoolerVideoContent/WaterCoolerVideoContent";
import useWaterCoolerJoinMember from "hooks/useWaterCoolerJoinMember";
import useWaterCoolerLeftMember from "hooks/useWaterCoolerLeftMember";
import { scrollToBottomOfWaterCooler } from "utils/helpers";
import { useWaterCoolerContext } from "store/contexts/waterCoolerContext";

const useStyle = {
  loaderHeading: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "10px",
  },
  loaderButton: {
    width: "50%",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
  },
};

export default ({ handleScroll, closeJoinWaterCooler }) => {
  const classes = useStyle;
  const { setAllMessages, channelInformation, allMessages, total, setTotal } =
    useWaterCoolerContext();
  const [page, setPage] = useState(1);
  const [videoContent, setVideoContent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const joinMember = useWaterCoolerJoinMember({ channelInformation });
  const leftMember = useWaterCoolerLeftMember({ channelInformation });

  useEffect(() => {
    if (joinMember.member !== undefined) {
      let messageObject = {
        type: "status",
        memberInformation: joinMember.member,
        status: "joined",
      };
      setTotal(total + 1);
      setAllMessages([...allMessages, messageObject]);

      setTimeout(function () {
        scrollToBottomOfWaterCooler();
      }, 1000);
    }
    //eslint-disable-next-line
  }, [joinMember.member]);

  useEffect(() => {
    if (leftMember.member !== undefined) {
      let messageObject = {
        type: "status",
        memberInformation: leftMember.member,
        status: "left",
      };
      setTotal(total + 1);
      setAllMessages([...allMessages, messageObject]);

      setTimeout(function () {
        scrollToBottomOfWaterCooler();
      }, 1000);
    }
    //eslint-disable-next-line
  }, [leftMember.member]);

  useEffect(() => {
    scrollToBottomOfWaterCooler();
    //eslint-disable-next-line
  }, []);

  window.addEventListener("beforeunload", function (e) {
    e.preventDefault();
    closeJoinWaterCooler();
  });

  useEffect(() => {
    try {
      (async () => {
        var response = await messageCount(channelInformation);
        setTotal(response);
        setIsLoading(false);
      })();
    } catch (e) {
      console.log(e);
    }
    // eslint-disable-next-line
  }, []);

  const getNextPageData = async () => {
    try {
      setIsLoading(true);

      await handleScroll();

      setPage(page + 1);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={classes.loader} />
        </h4>
      )}
      {!isLoading && (
        <h4 style={classes.loaderHeading}>
          <Button
            color="warning"
            buttonClass={"loaderButton grad_btn"}
            onClick={getNextPageData}
          >
            Load More
          </Button>
        </h4>
      )}
    </>
  );

  return (
    <div className="watercooler-page">
      <WaterCoolerHeader
        videoContent={videoContent}
        closeVideoContent={() => setVideoContent(false)}
        showVideoContent={() => setVideoContent(!videoContent)}
      />
      <div className="wc-chat-body" id="scrollableDiv">
        <Scrollbar className="wc-scroll">
          {!videoContent && (
            <InfiniteScroll
              dataLength={total ?? 0}
              next={getNextPageData}
              style={{
                // overflow: "hidden",
                display: "flex",
                flexDirection: "column-reverse",
              }}
              inverse={true}
              initialScrollY={0}
              scrollThreshold={"555px"}
              hasMore={allMessages.length !== total}
              loader={LoadingContainer}
              scrollableTarget="scrollableDiv"
            >
              <div id="watercooler-showMessage">
                <WaterCoolerContent />
              </div>
            </InfiniteScroll>
          )}
          {videoContent && <WaterCoolerVideoContent />}
        </Scrollbar>
      </div>
      {!videoContent && <WaterCoolerFooter />}
    </div>
  );
};
